import { render } from "./FavoritEventsList.vue?vue&type=template&id=202d9d12&scoped=true"
import script from "./FavoritEventsList.vue?vue&type=script&lang=js"
export * from "./FavoritEventsList.vue?vue&type=script&lang=js"

import "./FavoritEventsList.vue?vue&type=style&index=0&id=202d9d12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-202d9d12"]])

export default __exports__